<div mat-dialog-title></div>
<div class="m-2">
  <h2 class="ap-blue">{{ 'ml_144088' | translate }} {{ 'ml_143925' | translate }}</h2>

  <div mat-dialog-content class="m-0">
    <form [formGroup]="editForm" ngxsForm="{{formPath}}" [ngxsFormDebounce]="500" [ngxsFormClearOnDestroy]="true">
      <div class="row mt-3">
        <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{'ml_144095' | translate}}</mat-label>
            <input matInput onlyNumber placeholder="" formControlName="mileage" />
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{'ml_144096' | translate}}</mat-label>
            <input matInput onlyNumber placeholder="" formControlName="cylinder" />
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{ ('ml_144092' | translate)}}</mat-label>
            <input matInput [matDatepicker]="yearMonth" formControlName="achieveDate">
            <mat-hint>MM/YYYY</mat-hint>
            <mat-datepicker-toggle matSuffix [for]="yearMonth"></mat-datepicker-toggle>
            <mat-datepicker #yearMonth startView="multi-year" (monthSelected)="setMonthAndYear($event, yearMonth, 'achieveDate')">
            </mat-datepicker>
          </mat-form-field>
        </div>
      </div>
    </form>
  </div>

  <div mat-dialog-actions class="row m-0 p-2 justify-content-end">
    <spinner-button class="me-3 col-auto" [refreshState$]="updating$" [disabled]="editForm.invalid" label="{{ 'ml_143934' | translate }}" refreshLabel="{{ 'ml_143923' | translate }}"
      (clicked)="onOkClick()">
    </spinner-button>
    <button (click)="onCancelClick()" class="button--default button-back col-auto">{{ 'ml_143935' | translate }}</button>
  </div>
</div>
